import * as React from "react";
import { Text, Layout, Flex, Box } from "@draftkings/arena-web";
import { SportsbookContext } from "blocks/MyBetsList/contexts";
export const ReplayCard = React.memo(function ReplayCard({ replayData }) {
    const { dictionary } = React.useContext(SportsbookContext);
    const { pitcherName, batterName, eventName, startEventDate, stats } = replayData;
    return (React.createElement(Layout, { variant: "replayCard", testId: "replay-card" },
        React.createElement(Flex, null,
            React.createElement(Box, { width: "calc(40% - 17px)", paddingTop: "6px", paddingBottom: "6px" },
                React.createElement(Flex, { gap: "4px", alignItems: "center", marginBottom: "8px" },
                    React.createElement(Text, { as: "span", variant: "replayLabel" },
                        dictionary.myBetsDictionary.Pitcher,
                        ":"),
                    React.createElement(Text, { testId: "replay-card-pitcher", variant: "replayPlayerName" }, pitcherName)),
                React.createElement(Flex, { gap: "4px", alignItems: "center" },
                    React.createElement(Text, { as: "span", variant: "replayLabel" },
                        dictionary.myBetsDictionary.Batter,
                        ":"),
                    React.createElement(Text, { testId: "replay-card-batter", variant: "replayPlayerName" }, batterName))),
            React.createElement(Box, { borderLeft: "1px solid #4D4D4D", margin: "0 8px" }),
            React.createElement(Box, { maxWidth: "calc(60% - 17px)", paddingTop: "2px", paddingBottom: "2px" },
                React.createElement(Text, { testId: "replay-card-event-name", variant: "replayRegular" }, eventName),
                React.createElement(Box, { margin: "2px 0" },
                    React.createElement(Text, { testId: "replay-card-start-date", variant: "replayRegular" }, startEventDate)),
                React.createElement(Flex, null, stats.map((stat, index) => {
                    const isLastStat = index === stats.length - 1;
                    return (React.createElement(Flex, { key: index },
                        React.createElement(Text, { testId: `replay-card-stat-${index}`, as: "span", variant: "replayLabel" }, stat),
                        !isLastStat && React.createElement(Box, { borderLeft: "1px solid #4D4D4D", margin: "1px 6px" })));
                }))))));
});
//# sourceMappingURL=ReplayCard.js.map